import React from "react";

class ValueRangeStatus {
   public Limit1: string ="Alarm Limit1";
   public Limit2 : string ="Alarm Limit2";
   public Reject: string ="Reject Limit";
   public WithinLimit: string ="Within Limit";

}

const valueRangeStatus = new ValueRangeStatus();
export default valueRangeStatus;